import { render, staticRenderFns } from "./FcPlug.vue?vue&type=template&id=63af72e7"
import script from "./FcPlug.vue?vue&type=script&lang=js"
export * from "./FcPlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports